import { render, staticRenderFns } from "./viewFeeDetail.vue?vue&type=template&id=6dde275c&scoped=true"
import script from "./viewFeeDetail.vue?vue&type=script&lang=js"
export * from "./viewFeeDetail.vue?vue&type=script&lang=js"
import style0 from "./viewFeeDetail.vue?vue&type=style&index=0&id=6dde275c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dde275c",
  null
  
)

export default component.exports